import { Form, useFormApi } from "informedv4";
import * as React from "react";
import { Link } from "react-router-dom";
import { TextBox } from "../../forms/informedv4/TextBoxV4";
import { Required, RequiredNotBlank } from "../../forms/validation/Required";
import { EDiaryConfiguration } from "../../misc/api/apiTypes";
import Alert, { AlertCategoryEnum } from "../../misc/components/Alert";
import DocumentTitle from "../../misc/components/DocumentTitle";
import { useWebPortalLegacyClient } from "../../misc/api/WebPortalTokenClient";

export interface DiaryConfiguratonFormModel {
    Name: string;
    Description: string;
}

export interface DiaryConfigurationFormProps {
    submitApi: (form: EDiaryConfiguration) => Promise<EDiaryConfiguration>;
}

export const DiaryConfigurationForm = ({ submitApi }: DiaryConfigurationFormProps) => {
    const [alertShown, setAlertShown] = React.useState(false);
    const [submitting, setSubmitting] = React.useState(false);
    const [errorAlert, setErrorAlert] = React.useState<string>(null);
    const formApi = useFormApi();

    const onSubmit = async () => {
        setSubmitting(true);
        setErrorAlert(null);

        formApi.validate();
        const state = formApi.getFormState();

        if (state.invalid) {
            setSubmitting(false);
            return;
        }

        const apiForm: EDiaryConfiguration = {
            Name: state.values.Name as string,
            Description: state.values.Description as string,
        }

        try {
            const config = await submitApi(apiForm);

            if (config) {
                setAlertShown(true);
            }
        } catch (ex) {
            setErrorAlert(ex.Message);
        }

        setSubmitting(false);
    }

    return (
        <>
            <Alert show={alertShown} category={AlertCategoryEnum.Success}>
                Saved successfully. Return to{" "}
                <Link to={`/DiaryConfigurations`}>Diary Configurations list</Link>?
            </Alert>
            <Alert show={errorAlert !== null} category={AlertCategoryEnum.Danger}>
                {errorAlert}
            </Alert>
            <div className="row">
                <div className="col-md-6">
                    <h2 className="text-primary">Diary Configuration</h2>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <div className="panel panel-primary">
                        <div className="panel-body">
                            <div className="row">
                                <div className="col-md-12">
                                    <label htmlFor="Name">Name</label>
                                    <TextBox
                                        name="Name"
                                        id="Name"
                                        field="Name"
                                        validate={RequiredNotBlank}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <label htmlFor="Description">Description</label>
                                    <TextBox
                                        name="Description"
                                        id="Description"
                                        field="Description"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <div className="h2 pull-right">
                        <button className="btn btn-primary" type="submit" disabled={submitting} onClick={onSubmit} data-automationid="DiaryConfiguration_Save">
                            Save
                        </button>&nbsp;
                        <Link className="btn btn-primary btn-outline" to="/DiaryConfigurations" data-automationid="DiaryConfiguration_ReturnToList">
                            Return to List
                        </Link>
                    </div>
                </div>
            </div>
        </>
    );
}

export const CreateDiaryConfigurationScreen = () => {
    const legacyClient = useWebPortalLegacyClient();

    return (
        <DocumentTitle title="Create Diary Configuration | Vitalograph Web Portal">
            <Form validateOn="submit" noValidate>
                <DiaryConfigurationForm submitApi={legacyClient.createEDiaryConfiguration.bind(legacyClient)} />
            </Form>
        </DocumentTitle>
    );
}
